"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomizeEnum = exports.generateRandomPhotoURL = void 0;
/**
 * Generates Random Photo URL.
 * @returns PNG UI Avatar Link
 * @param name - Any valid person name without a title & special characters.
 * @example
 * ```ts
 * generateRandomPhotoURL("John Doe") // https://avatars.dicebear.com/api/micah/John+Doe.png
 * ```
 */
function generateRandomPhotoURL(name) {
    return `https://ui-avatars.com/api/?name=${name}.png`.replace(/\s+/g, '+');
}
exports.generateRandomPhotoURL = generateRandomPhotoURL;
/**
 * Generates Random Enum Values.
 * @param enumObject - Pass the enum you want to randomize
 * @returns Random enum value
 * @example
 * ```ts
 * randomizeEnum(AccountTypes) // Admin
 * randomizeEnum(Sector) // Demolition
 * randomizeEnum(Color) // Red
 * ```
 */
function randomizeEnum(enumObject) {
    const values = Object.values(enumObject);
    const randomIndex = Math.floor(Math.random() * values.length);
    return values[randomIndex];
}
exports.randomizeEnum = randomizeEnum;
